module.exports = __webpack_public_path__ + "static/media/refer_friend_sht.c90dc6d6.png";